import * as React from 'react';
type IconRelevamientoARProps = React.SVGProps<SVGSVGElement>;

export const IconRelevamientoAR: React.FC<IconRelevamientoARProps> = (props) => (
	<svg
		width={66}
		height={66}
		viewBox="0 0 66 66"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<mask
			id="mask0_4527_29619"
			maskUnits="userSpaceOnUse"
			x="0"
			y="0"
			width="66"
			height="66">
			<circle
				cx="33"
				cy="33"
				r="32.5"
				fill="#EBF8F0"
			/>
		</mask>
		<g mask="url(#mask0_4527_29619)">
			<circle
				cx="33"
				cy="33"
				r="32.5"
				fill="#EBF8F0"
			/>
			<rect
				x="-2"
				y="-1.5"
				width="70"
				height="21"
				fill="#7EAE90"
			/>
			<rect
				x="-2"
				y="45.5"
				width="70"
				height="22"
				fill="#7EAE90"
			/>
		</g>
		<g clipPath="url(#clip0_4527_29619)">
			<path
				d="M32.2679 42C31.8184 41.7907 31.7221 41.5344 31.9224 41.0842C32.009 40.8892 32.1313 40.7185 32.2771 40.5607C32.8075 39.9852 32.808 39.4266 32.2934 38.8423C31.7762 38.2549 31.6019 37.5805 31.7685 36.821C31.7996 36.6795 31.8516 36.6484 31.9983 36.6805C32.2837 36.7434 32.5767 36.7567 32.8697 36.7468C32.9568 36.7438 33.022 36.7374 32.9629 36.8621C32.7306 37.3529 32.8549 37.7804 33.209 38.1753C33.8108 38.8452 33.9622 39.6107 33.6783 40.4553C33.6029 40.6799 33.4862 40.8867 33.3323 41.0693C33.1596 41.2747 32.9767 41.4686 32.8793 41.7254C32.8233 41.8734 32.6623 41.9218 32.5354 41.9995H32.2684L32.2679 42Z"
				fill="#FFA692"
			/>
			<path
				d="M32.916 23C32.9349 23.0139 32.9517 23.0307 32.9721 23.0411C33.3751 23.2494 33.4551 23.619 33.1591 23.9614C32.9053 24.2553 32.808 24.5843 32.8788 24.9604C32.9267 25.2127 33.0765 25.4086 33.2457 25.5977C33.8714 26.2988 33.9897 27.2799 33.5601 28.1077C33.4908 28.2413 33.4246 28.3061 33.2452 28.2809C32.8442 28.2245 32.4375 28.2423 32.0172 28.3116C32.0849 28.1419 32.1945 28.031 32.2995 27.9172C32.7983 27.3769 32.8014 26.7881 32.3071 26.2414C31.5198 25.3705 31.5127 24.1108 32.2852 23.2439C32.3789 23.139 32.5002 23.0787 32.6108 23C32.7127 23 32.8146 23 32.916 23Z"
				fill="#FFA692"
			/>
			<path
				d="M42.5278 32.9824C42.3067 33.4218 42.0483 33.5133 41.5856 33.3194C41.3726 33.2303 41.1907 33.0997 41.019 32.9498C40.4656 32.4678 39.8669 32.4663 39.3094 32.9349C38.6776 33.4658 37.9586 33.54 37.1841 33.3025C37.1127 33.2808 37.0597 33.2531 37.0766 33.1605C37.1423 32.7939 37.1448 32.4238 37.1056 32.0299C37.3176 32.1343 37.499 32.2457 37.7125 32.2892C38.031 32.354 38.3214 32.3125 38.5645 32.0908C39.4761 31.2595 40.8957 31.2759 41.7895 32.1264C41.8623 32.1957 41.9413 32.266 42.0386 32.2937C42.2756 32.3605 42.4264 32.5129 42.5283 32.7217V32.9814L42.5278 32.9824Z"
				fill="#FFA692"
			/>
			<path
				d="M29.5387 32.4401C29.5749 30.7172 31.0572 29.3214 32.807 29.3635C34.5818 29.406 36.0177 30.8162 35.9887 32.4876C35.9566 34.3411 34.5502 35.6656 32.6439 35.6167C31.0174 35.5746 29.5759 34.4232 29.5387 32.4406V32.4401Z"
				fill="#FFA692"
			/>
			<path
				d="M35.6309 29.2927C35.6554 29.2467 35.6956 29.2447 35.7303 29.2304C36.2246 29.0246 36.5053 28.6614 36.543 28.1389C36.6169 27.1221 37.1153 26.4081 38.1002 26.0331C38.3086 25.9534 38.5288 25.9163 38.7509 25.9059C38.943 25.897 39.1239 25.8623 39.3048 25.7916C39.5968 25.6778 39.8913 25.8025 40.0208 26.0731C40.1517 26.3472 40.0605 26.6357 39.7823 26.7896C39.5005 26.9454 39.1917 26.9999 38.8692 27.0132C38.2021 27.0404 37.7471 27.4764 37.6916 28.1235C37.6804 28.2527 37.6732 28.3828 37.6472 28.5095C37.5112 29.1809 37.1392 29.6965 36.5542 30.0725C36.4508 30.1393 36.3876 30.1458 36.3122 30.0329C36.1242 29.7524 35.8791 29.5184 35.6309 29.2922V29.2927Z"
				fill="#FFA692"
			/>
			<path
				d="M29.0164 34.6924C28.8177 34.6894 28.6694 34.6355 28.5201 34.587C27.8215 34.3584 27.2671 34.5865 26.9466 35.2342C26.4197 36.3 25.1871 36.8027 24.0681 36.4083C23.7435 36.294 23.586 36.0036 23.6859 35.7038C23.7837 35.4099 24.0941 35.2624 24.4222 35.3544C25.1081 35.5464 25.6283 35.3213 25.9437 34.6944C26.3911 33.8057 27.2574 33.3213 28.2648 33.3916C28.4182 33.4025 28.5119 33.4381 28.5512 33.6128C28.6347 33.9873 28.8059 34.3332 29.0159 34.6929L29.0164 34.6924Z"
				fill="#FFA692"
			/>
			<path
				d="M30.5155 28.8519C30.5084 28.6797 30.5476 28.5461 30.6021 28.4244C30.8707 27.8252 30.6383 27.1389 29.9061 26.8074C28.8477 26.3289 28.3616 25.1429 28.7341 24.0732C28.8528 23.7328 29.1545 23.568 29.4745 23.6689C29.7807 23.7654 29.927 24.0727 29.8261 24.4052C29.633 25.042 29.8719 25.5615 30.4951 25.8584C31.4144 26.2963 31.9 27.0983 31.85 28.0894C31.8414 28.2571 31.8098 28.37 31.6009 28.41C31.2202 28.4833 30.8742 28.6569 30.516 28.8509L30.5155 28.8519Z"
				fill="#FFA692"
			/>
			<path
				d="M31.3563 36.5276C31.0179 36.7894 30.8447 37.1036 30.8559 37.5043C30.86 37.6488 30.9017 37.7844 30.9476 37.919C31.3333 39.055 30.8207 40.2158 29.7058 40.723C29.5489 40.7942 29.4082 40.8808 29.2834 41.0005C29.0541 41.2207 28.7162 41.2247 28.4925 41.0228C28.2597 40.8135 28.2439 40.483 28.4564 40.2391C28.649 40.0179 28.892 39.8645 29.1596 39.7418C29.8398 39.4301 30.0712 38.8992 29.8398 38.203C29.5947 37.4653 29.7043 36.7785 30.1573 36.1402C30.2347 36.0313 30.2954 35.9918 30.4273 36.0833C30.7025 36.2738 31.0133 36.4019 31.3568 36.5266L31.3563 36.5276Z"
				fill="#FFA692"
			/>
			<path
				d="M28.5359 31.4084C28.4085 31.2823 28.3494 31.1516 28.2852 31.025C27.9565 30.3738 27.4072 30.1571 26.6862 30.3946C25.5397 30.7721 24.3412 30.2986 23.8189 29.2605C23.663 28.9508 23.7608 28.6262 24.0533 28.4817C24.3402 28.3397 24.6617 28.4471 24.8289 28.741C25.1774 29.3521 25.7017 29.547 26.3856 29.3189C27.3624 28.9934 28.4009 29.2828 29.0108 30.0448C29.0826 30.1348 29.0989 30.1977 29.0302 30.3011C28.809 30.6336 28.6607 31.0007 28.5354 31.4084H28.5359Z"
				fill="#FFA692"
			/>
			<path
				d="M30.087 35.8612C29.8989 35.9324 29.7257 35.9284 29.556 35.9403C28.8931 35.9868 28.4538 36.4119 28.411 37.0546C28.3321 38.2332 27.5219 39.0882 26.3397 39.2396C25.9458 39.2901 25.6788 39.154 25.5917 38.8581C25.4897 38.5113 25.7078 38.1896 26.0773 38.1426C26.8788 38.0407 27.2243 37.6805 27.2732 36.8958C27.3313 35.9651 28.0758 35.1115 29.0138 34.8968C29.0888 34.8795 29.1412 34.8711 29.1927 34.9438C29.4358 35.2862 29.7328 35.5806 30.0875 35.8607L30.087 35.8612Z"
				fill="#FFA692"
			/>
			<path
				d="M29.3094 29.8969C29.2334 29.7019 29.2401 29.5213 29.2258 29.3442C29.1774 28.7396 28.7234 28.3022 28.1022 28.2675C26.888 28.1992 26.0079 27.4229 25.8403 26.2701C25.8225 26.1483 25.8082 26.0261 25.8474 25.9029C25.929 25.6466 26.1766 25.4715 26.4344 25.4937C26.7116 25.518 26.9302 25.7248 26.9639 25.9949C27.0602 26.7673 27.4367 27.1097 28.2444 27.1587C29.2029 27.2171 30.0808 27.9415 30.301 28.8514C30.3183 28.9231 30.328 28.9756 30.2526 29.026C29.9 29.2621 29.5978 29.5515 29.3089 29.8969H29.3094Z"
				fill="#FFA692"
			/>
			<path
				d="M28.4574 33.2358C28.2836 33.1522 28.1644 33.0517 28.0467 32.9488C27.4938 32.4679 26.891 32.4644 26.3381 32.9379C25.4423 33.7058 24.1414 33.7197 23.2543 32.9711C22.9628 32.7252 22.917 32.3917 23.1401 32.1378C23.3572 31.8909 23.6981 31.882 23.9886 32.1156C24.5083 32.5337 25.0943 32.5109 25.6416 32.0518C26.386 31.4268 27.3797 31.3026 28.2367 31.7197C28.3804 31.7895 28.4518 31.8593 28.4243 32.0389C28.3657 32.4248 28.3881 32.8147 28.4574 33.2353V33.2358Z"
				fill="#FFA692"
			/>
			<path
				d="M36.1686 35.1709C36.3571 35.734 36.7153 36.0422 37.3018 36.0729C38.5467 36.1382 39.3151 37.0021 39.4929 37.8641C39.5204 37.9967 39.5393 38.1327 39.5454 38.2678C39.5525 38.4242 39.5831 38.5706 39.6463 38.7161C39.7752 39.0135 39.655 39.3247 39.3737 39.4528C39.0822 39.5859 38.7586 39.4692 38.6063 39.1718C38.483 38.9313 38.4178 38.6755 38.4081 38.4059C38.38 37.6553 37.9403 37.2263 37.1709 37.1773C36.38 37.1268 35.7813 36.7557 35.3507 36.114C35.2896 36.0224 35.2774 35.9641 35.3859 35.8918C35.6794 35.6964 35.9189 35.4401 36.1686 35.1704V35.1709Z"
				fill="#FFA692"
			/>
			<path
				d="M36.6307 30.5159C37.2381 30.5461 37.6289 30.2938 37.8776 29.797C38.4365 28.6802 39.5871 28.2112 40.7938 28.6026C40.9522 28.654 41.1097 28.6827 41.2784 28.6812C41.6203 28.6783 41.8643 28.9138 41.8674 29.2324C41.8705 29.5402 41.6371 29.7688 41.3008 29.7915C41.0108 29.8113 40.7331 29.7584 40.4595 29.6678C39.7604 29.4373 39.2126 29.6654 38.8885 30.316C38.5487 30.9978 38.0075 31.4343 37.2411 31.5985C37.1025 31.6282 37.0235 31.6163 36.9909 31.4526C36.9267 31.1314 36.7866 30.8331 36.6307 30.5169V30.5159Z"
				fill="#FFA692"
			/>
			<path
				d="M34.8294 36.2505C34.8243 36.4296 34.8207 36.5894 34.8681 36.7443C34.9777 37.0996 35.2223 37.3281 35.5621 37.4865C36.3443 37.8511 36.7871 38.4617 36.9007 39.2974C36.9456 39.6284 36.8967 39.951 36.7876 40.2647C36.726 40.4419 36.6867 40.6175 36.6883 40.8075C36.6913 41.1118 36.4411 41.3538 36.139 41.3637C35.8414 41.3736 35.5779 41.141 35.5504 40.8412C35.5244 40.5532 35.5749 40.2766 35.6707 40.0035C35.9137 39.3103 35.6809 38.7799 35.0062 38.4587C34.2979 38.1213 33.8577 37.5825 33.7114 36.822C33.689 36.7057 33.7038 36.6443 33.8403 36.6161C34.1817 36.5454 34.5007 36.4088 34.8289 36.251L34.8294 36.2505Z"
				fill="#FFA692"
			/>
			<path
				d="M36.9649 33.6751C36.9996 33.7072 37.023 33.726 37.0434 33.7473C37.4062 34.1397 37.8434 34.2431 38.355 34.0748C39.6055 33.6642 40.7341 34.1125 41.3252 35.2559C41.3945 35.39 41.4801 35.5078 41.5912 35.6132C41.8256 35.8358 41.8394 36.1752 41.632 36.3964C41.418 36.625 41.0852 36.6418 40.8269 36.434C40.6078 36.2579 40.4472 36.0387 40.3219 35.7913C39.9718 35.1015 39.4419 34.8942 38.6888 35.1377C37.9463 35.3776 37.2508 35.2762 36.6016 34.8512C36.4997 34.7844 36.4696 34.7314 36.5435 34.6186C36.7316 34.3311 36.8554 34.013 36.9649 33.6746V33.6751Z"
				fill="#FFA692"
			/>
			<path
				d="M33.8898 28.3927C34.003 28.2789 34.1227 28.2364 34.2338 28.182C34.9237 27.8406 35.1428 27.3096 34.8865 26.5986C34.4865 25.4888 34.9594 24.3246 36.0223 23.8011C36.3357 23.6467 36.6741 23.7397 36.8244 24.0213C36.9721 24.2978 36.8636 24.614 36.565 24.7788C35.9398 25.1241 35.7467 25.6338 35.9892 26.2993C36.3301 27.2344 36.0605 28.2285 35.3069 28.8356C35.2086 28.9147 35.1367 28.9429 35.0139 28.8648C34.6786 28.651 34.3082 28.507 33.8898 28.3932V28.3927Z"
				fill="#FFA692"
			/>
		</g>
		<defs>
			<clipPath id="clip0_4527_29619">
				<rect
					width="19.5278"
					height="19"
					fill="white"
					transform="translate(23 23)"
				/>
			</clipPath>
		</defs>
	</svg>
);
export default IconRelevamientoAR;
